"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const react_2 = require("@emotion/react");
const cache_1 = __importDefault(require("@emotion/cache"));
const stylis_1 = require("stylis");
const stylis_plugin_rtl_1 = __importDefault(require("stylis-plugin-rtl"));
const jss_1 = require("jss");
const jss_rtl_1 = __importDefault(require("jss-rtl"));
const styles_2 = require("@mui/styles");
const provider_settings_1 = require("@framework/provider-settings");
const palette_1 = require("./palette");
const ThemeProvider = props => {
    const { darkPalette = palette_1.dark, lightPalette = palette_1.light, options = {}, children } = props;
    const settings = (0, provider_settings_1.useSettings)();
    const direction = settings.getLayoutDirection();
    const cacheRtl = (0, cache_1.default)({
        key: "muirtl",
        prepend: true,
        stylisPlugins: [stylis_1.prefixer, stylis_plugin_rtl_1.default],
    });
    const cacheLtr = (0, cache_1.default)({
        key: "muiltr",
        prepend: true,
        stylisPlugins: [stylis_1.prefixer],
    });
    const jss = (0, jss_1.create)({
        plugins: [...(0, styles_2.jssPreset)().plugins, (0, jss_rtl_1.default)()],
    });
    const theme = (0, styles_1.createTheme)({
        palette: {
            light: lightPalette,
            dark: darkPalette,
        }[settings.getTheme()],
        direction,
        ...options,
    });
    (0, react_1.useEffect)(() => {
        document.dir = direction;
    }, [direction]);
    return ((0, jsx_runtime_1.jsx)(react_2.CacheProvider, { value: direction === "rtl" ? cacheRtl : cacheLtr, children: (0, jsx_runtime_1.jsx)(styles_2.StylesProvider, { jss: jss, children: (0, jsx_runtime_1.jsx)(styles_1.StyledEngineProvider, { injectFirst: true, children: (0, jsx_runtime_1.jsxs)(styles_1.ThemeProvider, { theme: theme, children: [(0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), children] }) }) }) }));
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=provider.js.map